import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { PaymentChannelContainerModel } from "../../../../../models/aggregates/pgw/payment-channel.model";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
} from "../shared";
import {
  PaymentChannelQueryCriteriaClass,
  PaymentChannelCriteriaModelQuery,
} from "../../criteria/pgw/payment-channel-criteria.model";

@Injectable({
  providedIn: "root",
})
export class PaymentChannelService extends BaseApiTemplateService<PaymentChannelContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "paymentchannels";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "paymentchannels";
    this.httpClient = http;
  }

  getPaymentChannelByCriteria(
    visa: ApiVisa,
    criteria?: PaymentChannelQueryCriteriaClass
  ): Observable<PagingResponseModel<PaymentChannelContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildPaymentChannelCriteriaCriteria = new PaymentChannelCriteriaModelQuery(criteria);
    console.log("query", buildPaymentChannelCriteriaCriteria.query);
    return this.httpClient.get<PagingResponseModel<PaymentChannelContainerModel>>(
      this.apiUrl + "/query?" + buildPaymentChannelCriteriaCriteria.query,
      this.getHttpHeader(visa)
    );
  }

  uploadFileAndDetails(formData: FormData, file_type: string, hdrGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + '/add-files/' + hdrGuid + '?file-type=' + file_type;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-files/' + hdrGuid + '?file-type=' + file_type;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  getPublicFileAndDetails(formData: FormData, file_type: string, extGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + '/public/file/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/public/file/' + extGuid;
    }
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  deleteFileAndDetails(extGuid: string, visa: ApiVisa){
    let url = visa.api_domain_url + this.endpoint_path + "/file/" + extGuid;
    if (this.endpoint_path && visa.api_domain_url){
      url = visa.api_domain_url + this.endpoint_path + "/file/" + extGuid;
    }
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }

  getExtDetailsByGuid(extGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + "/file/" + extGuid;
      if (this.endpoint_path && visa.api_domain_url) {
        url = visa.api_domain_url + this.endpoint_path + "/file/" + extGuid;
      }
      return this.httpClient.get(url, this.getHttpHeader(visa));
    }
}
